module.exports = require("./lv-LV.js");